/* istanbul ignore file */
import {generatePath} from "react-router";

const urls = {
  home: "/",

  signup: "/login/sign-up/",
  login: "/login/",
  loginForgotPassword: "/login/forgot-password/",
  loginResetPassword: "/login/reset_password/:hash/",
  loginWithProvider: "/login/:provider/",
  loginSelectAccount: "/login/account/",

  editor: "/editor/",
  editorChallengeList: "/editor/",
  editorChallengeEdit: "/editor/:id/",
  editorProjectEdit: "/editor/project/:id/",

  player: "/play/",
  playerPlay: "/play/:id/",
  playerResults: "/play/:challengeId/results/",
  playerUserResults: "/play/:challengeId/:userId/results/",
  playerProject: "/play/project/:id/",

  accountMembers: "/account/members/",
  accountMembersGroups: "/account/members/groups/",
  anonymousSessions: "/account/members/anonymous-sessions/",

  offlineTestSessions: "/offline-test-sessions/",

  lms: "/lms",
  lmsPlay: "/lms/play/:id/",
};

export function path(name: keyof typeof urls): string {
  if (!urls[name]) {
    throw Error(`UnknownRoute("${name}")`);
  }

  return urls[name];
}

type reverseParams = {[key: string]: string | number | boolean | undefined};

export function reverse(name: keyof typeof urls, params?: reverseParams) {
  return generatePath(path(name), params);
}

export function getChallengeId() {
  const match = /\/play\/(\d+(?:_.+)?)(?:$|\/)/.exec(window.location.pathname);
  if (match) {
    return match[1];
  }
  return null;
}

export function getProjectId() {
  const match = /\/play\/project\/(\d+(?:_.+)?)(?:$|\/)/.exec(window.location.pathname);
  if (match) {
    return match[1];
  }
  return null;
}
